module.exports = __webpack_public_path__ + "static/img/03.32221b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/image/index/03.png
// module id = j1EP
// module chunks = 1